<template>
  <footer class="footer footer--basic">
    <p
      class="title title--5"
      :class="{
        'no-spacing': selectedLocation.storeId
      }"
    >
      {{ merchant.name }}
    </p>

    <p
      v-if="selectedLocation.storeId"
      class="smaller"
    >
      {{ locationAddress }}
    </p>

    <template v-if="merchant.linkGroupsByType.Footer">
      <div
        v-for="group in merchant.linkGroupsByType.Footer"
        :key="group.sortOrder"
        class="footer__links"
      >
        <template v-for="link in group.links">
          <a
            v-if="link.link"
            :key="link.displayName"
            class="link"
            :href="link.link"
            :target="link.opensNewTab ? '_blank' : '_self'"
          >
            {{ link.displayName }}
          </a>

          <p
            v-else
            :key="link.displayName"
            class="smaller"
          >
            {{ link.displayName }}
          </p>
        </template>
      </div>
    </template>

    <app-download-badges
      v-if="displayDownloadBadges"
      class="spacing"
      :title="content.ReceiptStandard.metadata.appDownloadText"
    />

    <p
      v-if="displayBranding"
      class="smaller"
    >
      Powered by <a
        class="link link--regular"
        href="https://cardfree.com/"
        target="_blank"
      >CardFree</a>
    </p>
  </footer>
</template>



<script>
  import { mapGetters } from 'vuex';

  import { formatAddressInline } from '@/helpers/address-format';



  export default {
    name: 'MainFooter',

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('content', ['content']),
      displayDownloadBadges() {
        return Boolean((this.merchant.features.aosUrl || this.merchant.features.iosUrl) && this.merchant.options.showAppDownloadButtonsOnFooter);
      },
      displayBranding() {
        return this.merchant.features['cardfree-branding-placement'] !== 'None';
      },
      locationAddress() {
        const addr = this.selectedLocation.address;
        if (!addr) return '';
        return formatAddressInline(addr, addr.countryCode);
      }
    }
  };
</script>
